import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import {
  Component,
  Input,
  Output,
  OnInit,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import { Location } from '@angular/common';
import { HistoryComponent } from '../history/history.component';
import { ApiHttpService } from 'src/app/core/services/apiHttpcall.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FiltersService } from 'src/app/core/services/filters.service';
import { TripHistorySidebarComponent } from '../trip-history-sidebar/trip-history-sidebar.component';
import { TripHistory } from '../interfaces/trip-history';
import { Response } from '../interfaces/response';

@Component({
  selector: 'page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  animations: [
    trigger('slideInOut', [
      state(
        'show',
        style({
          width: '150px',
        })
      ),
      state(
        'hide',
        style({
          opacity: '0',
          width: '0px',
        })
      ),
      transition('show => hide', animate('400ms ease-in-out')),
      transition('hide => show', animate('400ms ease-in-out')),
    ]),
  ],
})
export class PageHeaderComponent implements OnInit {
  headerActions: any[] = [];
  only_LongSearch: Boolean = false;
  LongSearchValue: any;
  historydetails: any;
  tripHistoryDetails: any;
  show_backButton: boolean = true;
  pageActions: any[] = [];
  isOpen: boolean = false;
  filter_applied: any = false;

  @Input('title') _title: any;
  @Input('detailText') _detailText: any;
  @Input('breadCrumbs') _breadCrumbs: any;
  @Input('show_create') show_create: any = true;
  @Input('show_history') show_history: any = false;
  @Input('StatusBadgeValue') StatusBadgeValue: string = "";
  @Input('manualBackHandling') manualBackHandling: boolean = false;
  _filter_applied(value: any) {
    //console.log(value);
    this.filter_applied = value;
  }

  @ViewChild('historySideBar_Ref') historySideBar_Ref: HistoryComponent;
  @ViewChild('TripHistorySideBar_Ref') TripHistorySideBar_Ref: TripHistorySidebarComponent;

  id: any;
  hops: any;
  moduleName: string;

  @Input('onlyLongSearch') set _onlyLongSearch(value: any) {
    this.only_LongSearch = value ? value : false;
  }

  @Input('headerActions') set _headerActions(value: any) {
    this.headerActions = value;
  }

  @Input('AllowGoBack') set _AllowGoBack(value: any) {
    this.show_backButton = value;
  }
  @Input('leadId') leadId: number = null;

  @Output() onActionSelect = new EventEmitter<any>();

  @Output('longSearchChange') _longSearchChange = new EventEmitter<any>();
  @Output('onBackPress') onBackPressEvent = new EventEmitter<'back' | undefined>();

  toggle_SearchBar: string = 'hide';

  constructor(private _location: Location, private httpService: ApiHttpService, private _activatedRoute: ActivatedRoute, private _router: Router,
    private filterService: FiltersService) {

    // this.pageActions = [
    //   {
    //     label: '',
    //     type: 'history-button',
    //     command: '',
    //     cssClass: '',
    //     value: false,
    //     isVisible: true,
    //     isDisabled: false,
    //   },
    // ];

  }

  ngOnInit() {
    this.id = this._activatedRoute.snapshot.params['id'];
    this.hops = this._activatedRoute.snapshot.params['hops'];
    const url = this._router.url
    const segments = url.split('/')
    this.moduleName = segments[2];

    console.log(this.moduleName);


    if(this.showHistory){
      this.headerActions.push({
        label: '',
        type: 'history-button',
        command: '',
        cssClass: '',
        value: false,
        isVisible: true,
        isDisabled: false,
      });
    }

    if (this._title.includes('Create')) {
      if (this.headerActions?.length) {
        this.headerActions.forEach((action: any) => {
          action.value = true;
        });
      }
    }

    console.log('title: ', this._title);
    if (this._title.includes('Details')) {
      this.getHistoryLog();
    } else if(this._title === 'Trip Request Detail') {
      // for trip request history
      // this.getTripHistoryLog();
    }

    this._activatedRoute.queryParams.subscribe((params) => {

      if (params['search'] && params['search'] !== '') {
        this.LongSearchValue = params['search'];
        this.toggle_SearchBar = this.LongSearchValue  ? 'show' : 'hide';
      }

    });

  }

  async getHistoryLog() {
    let url = `/activitylogs?module=${this.moduleName}&moduleId=${this.id}`;
    const resp = await this.httpService.get(url);
    if (resp.status == 200) {
      this.historydetails = resp.data;
    }
  }

  // async getTripHistoryLog() {
  //   let url = `/get-logs/${this.id}`;
  //   const resp = await this.httpService.get<Response<TripHistory[]>>(url);
  //   console.log('history res: ', resp);
  //   console.log('module name: ', this.moduleName);
  //   if (resp.status == 200) {
  //     this.tripHistoryDetails = resp.data;
  //   }
  // }

  ActionSelection(action: any) {
    if (!action.items){
      this.onActionSelect.emit(action);
    } else {
      this.toggle();
    }
  }

  toggle() {
    this.isOpen = !this.isOpen;
  }

  ItemSelection(item: any) {
    this.onActionSelect.emit(item);
  }

  onItemClick(event: any){
    // console.log(event?.item?.label)
    if(event?.item?.label === "Trip Request"){
      this.goBack();
    } else if(event?.item?.label === "Manage Trip"){
      this.goBackMultipleSteps(this.hops);
    }
    // this.goBackMultipleSteps(this.hops);
  }

  showHistory() {
    console.log('Showing history for module:', this.moduleName);
    if (this.moduleName == 'trip-requests' || this.moduleName == 'leads' || this.moduleName == 'customers' || this.moduleName == 'rejectedlead' || this.moduleName == 'inactivelead' || this.moduleName == 'inactive-customers') {
      this.TripHistorySideBar_Ref.show();
    } else {
      this.historySideBar_Ref.show();
    }
  }
  onDDChange(e:any, item:any){
    item.value = e.value;
    this.onActionSelect.emit(item);
  }

  toggleSearchBar() {
    //alert("yes");
    // If the search bar is empty then hide it
    if (!this.LongSearchValue) {
      this.toggle_SearchBar = this.toggle_SearchBar == 'hide' ? 'show' : 'hide';
    }
    this.toggle_SearchBar = 'show';
    // Commented the below code as the search bar should be show if the search bar has some value
    // this.toggle_SearchBar = this.toggle_SearchBar == 'hide' ? 'show' : 'hide';
  }

  goBack() {
    if(!this.manualBackHandling) return this._location.back();
    this.onBackPressEvent.emit('back');
  }

  goBackMultipleSteps(steps: number){
    for (let i = 0; i < steps; i++) {
      this._location.back();
    }
  }

  onlongSearchChange(val: any) {
    if (val.length >= 2 || val.length == 0) {
      this._longSearchChange.emit(val);
    }
    this.filterService.setSearch(this._title, val);
  }

  clearSearch() {
    this.LongSearchValue = '';
    this.toggle_SearchBar = 'hide';
    this.onlongSearchChange(this.LongSearchValue);
    this.filterService.setSearch(this._title, this.LongSearchValue);
  }
  onTabClick(tab: any, action: any) {
    if (tab.isDisabled) return;

    // Update active state
    action.tabs.forEach((t: any) => t.isActive = false);
    tab.isActive = true;

    // Emit the tab selection
    this.onActionSelect.emit({
        type: 'tab-selected',
        action: action,
        selectedTab: tab
    });
}
}
